import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { AuthGuard } from './features/auth/guards';
import { AdminGuard } from './features/auth/guards/admin.guard';

const routes: Routes = [
  {
    path: 'transportation',
    loadChildren: () =>
      import('./features/transportation/transportation.module').then(
        (m) => m.TransportationModule,
      ),
      canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/main/main.module').then((m) => m.MainModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'accommodations',
    loadChildren: () =>
      import('./features/accommodation/accommodation.module').then(
        (m) => m.AccommodationModule,
      ),
      canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: 'tours',
    loadChildren: () =>
      import('./features/tour/tour.module').then((m) => m.TourModule),
    canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: 'clients',
    loadChildren: () =>
      import('./features/client/client.module').then((m) => m.ClientModule),
    canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: 'users',
    loadChildren: () =>
      import('./features/user/user.module').then((m) => m.UserModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./features/admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: 'daily-program-items',
    loadChildren: () =>
      import('./features/daily-program-item/daily-program-item.module').then(
        (m) => m.DailyProgramItemModule,
      ),
      canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
